var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 0.166626C5.02008 0.166626 0.166748 5.01996 0.166748 11C0.166748 16.98 5.02008 21.8333 11.0001 21.8333C16.9801 21.8333 21.8334 16.98 21.8334 11C21.8334 5.01996 16.9801 0.166626 11.0001 0.166626ZM8.83342 16.4166L3.41675 11L4.94425 9.47246L8.83342 13.3508L17.0559 5.12829L18.5834 6.66663L8.83342 16.4166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.58c48f1be5a80d433d53e6f76249359d.svg";
export { ForwardRef as ReactComponent };